import { Box } from "@mui/material";
import { HeaderRupin, PINScreen } from "../../common";
import { useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { sendOTP } from "../../../SyncService";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { createUser, getUserFromId } from "../../../database/helpers/user";
import { useAuthContext } from "../../../context/AuthContext";
import BusinessLoader from "../../common/BusinessLoader";
import { setUserId, setUserProperties } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { incrementMigrationBannerLoginCount } from "../../../utils/rupinMigrationBanner";
import { useWalletContext } from "../../../context/WalletContext";
import { handleApi } from "../../../apis";
import { ACCOUNT_PIN_RESET, POST_LOGIN } from "../../../apis/configuration";
import { ParagraphText } from "../../../Libraries";
import { ArrowIcon } from "../../../assets/icons/icon";
import styles from "./styles.module.css";

const PINLogin = ({
  OTP,
  otpScreen,
  handleSendOtpFailure,
  onHandleVerifyScreen,
  resendOTPSuccess,
  handleLockedAccount,
}) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { setUser, setPinVerified } = useAuthContext();
  const { setWalletData, setKYCVerified } = useWalletContext();

  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submitVerifyPIN = async (pin) => {
    setValue(pin);
    setError("");
    if (pin.length === 4) {
      try {
        setLoading(true);
        const response = await handleApi(
          POST_LOGIN,
          {
            phone_number: otpScreen?.phone,
            otp: OTP,
            pin,
          },
          null,
          navigate,
          { "Web-Token": Cookies.get("deviceId") },
        );
        if (response?.otp_expired && resendOTPSuccess) {
          setLoading(true);
          let params = {
            phone_number: otpScreen?.phone,
            version: "multi-business",
            onboarding_type: "login",
          };
          const OTPresponse = await sendOTP(params);
          setLoading(false);
          resendOTPSuccess({
            phone: otpScreen?.phone,
            OTPresponse: OTPresponse.data,
          });
        }
        if (response?.otp_expired || !response?.success) {
          setValue("");
          setLoading(false);
          setError(
            response.attempts_left
              ? `${response.message} (${response.attempts_left} ${I18n.tries_left})`
              : response.message,
          );
          return;
        }
        let paramsForUser = {
          telco_network: "",
          phone_number: otpScreen?.phone,
          id: response.old_user_id,
          is_active: true,
        };

        getUserFromId(paramsForUser?.id).then(async (user) => {
          if (user.length) {
            user = user[0];

            if (!user.is_active) user = await user.activateUserOnly();

            const response = await handleApi(
              ACCOUNT_PIN_RESET,
              { phone_number: otpScreen?.phone },
              null,
              navigate,
              { "Api-Key": process.env.REACT_APP_API_KEY },
            );
            const isVerified = response?.verified;
            setKYCVerified(isVerified);
            setLoading(false);
            setUserProperties(analytics, {
              user_id: otpScreen?.phone,
            });
            setUserId(analytics, otpScreen?.phone);
            setUser(user);
            incrementMigrationBannerLoginCount();
            setWalletData();
            setPinVerified(true);
            navigate("/dataRestore", {
              state: {
                phone: otpScreen?.phone,
              },
            });
            triggerLogEvent(analytics, "login_pin_confirmed");
          } else {
            createUser(paramsForUser).then(() => {
              getUserFromId(paramsForUser?.id).then(async (user) => {
                if (user.length) {
                  const response = await handleApi(
                    ACCOUNT_PIN_RESET,
                    { phone_number: otpScreen?.phone },
                    null,
                    navigate,
                    { "Api-Key": process.env.REACT_APP_API_KEY },
                  );
                  const isVerified = response?.verified;
                  setKYCVerified(isVerified);
                  setLoading(false);
                  setUser(user[0]);
                  incrementMigrationBannerLoginCount();
                  setWalletData();
                  setPinVerified(true);
                  navigate("/dataRestore", {
                    state: {
                      phone: otpScreen?.phone,
                    },
                  });
                  triggerLogEvent(analytics, "login_pin_confirmed");
                }
              });
            });
          }
        });
      } catch (error) {
        setValue("");
        setLoading(false);
        if (
          (error.response?.data?.account_status === "pin_reset_required" ||
            error.response?.data?.is_locked) &&
          handleLockedAccount
        )
          handleLockedAccount();
        if (handleSendOtpFailure)
          handleSendOtpFailure(error.response, otpScreen?.phone);
      }
    }
  };

  const handleForgotPIN = async () => {
    try {
      setLoading(true);
      const response = await handleApi(
        ACCOUNT_PIN_RESET,
        { phone_number: otpScreen?.phone },
        null,
        navigate,
        { "Api-Key": process.env.REACT_APP_API_KEY },
      );
      const isVerified = response?.verified;
      if (Boolean(isVerified)) onHandleVerifyScreen();
      else {
        navigate("/ForgotPin", { state: { phone: otpScreen?.phone } });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <Box className={`${styles.verifyOTPWrapper} onBoardingScreenWrapper`}>
      <HeaderRupin>
        <ParagraphText
          className={styles.AccountRightSection}
          onClick={() => {
            triggerLogEvent(analytics, "login_forgot_pin");
            handleForgotPIN();
          }}
        >
          {I18n.forgot_pin} <ArrowIcon />
        </ParagraphText>
      </HeaderRupin>
      {loading ? (
        <BusinessLoader loadBusiness={loading} />
      ) : (
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          flexDirection={"column"}
          height={"calc(100% - 72px)"}
          className={styles.pinScreenWrapper}
        >
          <PINScreen
            onChangeQuery={submitVerifyPIN}
            value={value}
            error={error}
            id="pin_login"
          />
        </Box>
      )}
    </Box>
  );
};

export default PINLogin;
